import { useCallback } from "react";
import { useTranslation as useReactI18nextTranslation, Trans } from "react-i18next";

export { Trans };

export const usePaldockTranslation = (keyPrefix?: string) => {
    const { t: originalT, i18n } = useReactI18nextTranslation(undefined, { keyPrefix });

    // Must be stable across renders — callers pass `t` as a useMemo/useCallback dependency
    // throughout the app. A new function identity every render (the previous inline arrow
    // function here) silently defeats that memoization everywhere `t` is used as a dep.
    const t = useCallback(
        (...args: Parameters<typeof originalT>): ReturnType<typeof originalT> => originalT(...args),
        [originalT]
    );

    return { t, i18n };
};
